<template>
  <div class="widget--form_selection">
    <div class="form_selection">
      <div class="selected" @click="open">
        <div v-if="selected && selected.length > 0">
          <div class="select-wrap" v-for="(row,index) in selected" :key="index">
            <div class="clear-btn" @click="clear(index)" v-if="closeable">
              <fa :icon="['fas','times-circle']"/>
            </div>
              <div class="label">{{  row[label] }}</div>
          </div>
        </div>
        <div class="placeholder" v-else>
          <div class="label" v-if="!disabled">{{ $t("placeholder.please_select") }}</div>
          <div class="label" v-if="disabled">{{ $t("placeholder.invalid") }}</div>
        </div>
        <div class="space"></div>
        <div class="arrow" :class="{ 'show': show }">
          <fa :icon="['fas','chevron-down']"/>
        </div>
      </div>
      <div class="option-wrapper" :class="{ 'show': show }">
        <input type="text" v-if="filterable" v-model="filter"/>
        <div class="option-wrapper-content">
          <div class="option"
            :class="{ 'active': selectAll }"
            v-if="multiple && limit==0"
            >
            <input :id="'all-'+setup.label" v-if="multiple" @change="onSelectAll()" type="checkbox" v-model="selectAll" >
            <!-- {{ opt.label ? opt.label : setup && setup.label ? opt[setup.label] : opt.value }} -->
            <label :for="'all-'+setup.label">{{$t('label.all')}}</label>
          </div>
        </div>
        <div class="option-wrapper-content">
          <div class="option"
            v-for="(opt,index) in filtered_options"
            :key="index"
            :class="{ 'active': selected && setup && selected.filter(r=>r[setup.value] == opt[setup.value]).length > 0 }"
            @click="select(index)">
            <input v-if="multiple" type="checkbox" v-model="selectIndex" :value="opt[setup.value]">
            <!-- {{ opt.label ? opt.label : setup && setup.label ? opt[setup.label] : opt.value }} -->
            <span>{{ opt[label] }}</span>
          </div>
        </div>
          <div class="option not_found" v-if="filtered_options.length == 0">
            <div class="label">{{ $t("message.no_suitable_option_found") }}</div>
        </div>
      </div>
    </div>
    <div class="background-layer" :class="{ 'show': show }" @click="show=false"></div>
  </div>
</template>

<script>
export default {
  props: {
    option: {
      type: Array,
      default() {
        return [];
      }
    },
    default: {
      type: Boolean,
      default() {
        return false;
      }
    },
    setup: Object,
    limit: {
      type: Number,
      default() {
        return 0
      }
    },
    value: undefined,
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default() {
        return false
      }
    },
    filterable: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  mounted: function () {
    // Attach event listener to the root vue element
    this.$el.addEventListener('click', this.onClickThis);
    // Or if you want to affect everything
    document.addEventListener('click', this.onClick);
  },
  beforeDestroy: function () {
    
    document.removeEventListener('click', this.onClick);
    this.$el.removeEventListener('click', this.onClick);
  },
  beforeMount() {
    if(typeof this.value == "object"){
      if(Array.isArray(this.value)){
        this.selected = this.value;
      }
      else {
        this.selected = [this.value];
      }
    }
    // if(this.value != undefined){
    //   this.selected = [this.value];
    // }
    if(this.default && this.option.length > 0 && !this.selected) {
      this.selected = [this.option[0]];
    }
    this.selectCheckbox();
    // sorting
    // this.option.sort((a,b)=>{
    //   let al = a[this.label]?.toString().toUpperCase();
    //   let bl = b[this.label]?.toString().toUpperCase();

    //   if(al<bl) return -1;
    //   if(al>bl) return 1;
    //   return 0;
    // });
    this.$emit("input", this.selected);
  },
  methods: {
    selectCheckbox(){
      if(this.multiple){
        this.selectIndex = [];
        for(var i in this.selected){
          console.log(this.selected[i]);
          this.selectIndex.push(this.selected[i][this.setup.value]);
        }
        if(this.filtered_options.length == this.selected.length){
          this.selectAll = true;
        }
        else {
          this.selectAll = false;
        }

      }
    },
    onSelectAll(){
      this.selected = [];
      if(this.selectAll){
        this.selected = this.filtered_options;
      }
      this.$emit("input", this.selected);
      this.selectCheckbox();
    },
    onClickThis: function (ev) {
      this.click_this = true;
      // console.log('this.click_this',this.click_this)
    },
    onClick: function (ev) {
      // console.log('this.click_this',this.click_this);
      if(!this.click_this){
        this.show = false;
      }
      this.click_this = false;
      // console.log(ev.offsetX, ev.offsetY)
    },
    open() {
      console.log("open");
      if(this.disabled) {
        this.show = false;
        return;
      }
      this.show = !this.show;
    },
    close() {
      this.show = false;
    },
    select(index) {
      var arr = [];
      var obj = this.filtered_options[index];
      var val = this.setup.value;
      if(this.multiple){
        arr = this.selected.filter(row=>!(row[val]==obj[val]));
        if(this.limit != 0 && arr.length >= this.limit){
          alert(this.$t("message.max_limit", {limit : this.limit}));
        }
        else {
          
          if(arr.length == this.selected.length) {
            arr.push(obj);
          }
        }
      }
      else{
        arr.push(obj);
      }
      this.selected = arr;
      this.$emit("input", this.selected);
      this.filter = "";
      this.selectCheckbox();
      if(!this.multiple){
        this.close();
      }
      
    },
    clear(index) {
      console.log("clear");
      this.show = false;
      this.selected.splice(index, 1);
      this.$emit("input", this.selected);
      this.selectIndex = [];
      for(var i in this.selected){
        this.selectIndex.push(this.selected[i][this.setup.value]);
      }
      event.stopPropagation();
    }
  },
  computed: {
    label() {
      if(typeof this?.setup?.label == "undefined") return "";
      let label = this.setup.label;
      let split = label.split(".");
      if(split.length > 1) {
        label = split[split.length-1];
      }
      return label;
    },
    filtered_options() {
      let value = `${this.setup.value}`;
      if(!this.filterable) return this.option.sort((a,b)=>{
        if(typeof a[value] === 'number'){
          if(a[value]<b[value]) return -1;
          else return 1;
        }
        return `${a[value]}`.localeCompare(b[value]);
      });
      let langMap = this?.setup?.locale || {};
      if(typeof this.setup.locale == "boolean") {
        langMap = {
          en: "_en",
          zh: "_ch"
        };
      }
      let localeLabel = `${this.label}${langMap[this.$i18n.locale]||""}`;
      
      // return this.option.filter(opt=>opt[localeLabel]?.toUpperCase().includes(this.filter.toUpperCase()));
      return this.option.filter(opt=>opt[localeLabel]?.toString().toUpperCase().includes(this.filter.toUpperCase())).sort((a,b)=>`${a[value]}`.localeCompare(b[value]));
    }
  },
  data() {
    return {
      show: false,
      selectAll:false,
      selected: [],
      selectIndex: [],
      click_this:false,
      filter: ""
    }
  }
}
</script>

<style lang="scss">
.widget--form_selection{
  .form_selection{
    position: relative;
    width: calc(100% - 10px);
    border: 1px solid #aaa;
    border-radius: 4px;
    background: white;
    min-height: 25px;
    line-height:1.5;
    display: flex;
    padding: 5px;
    .selected{
      display: flex;
      align-items: center;
      justify-content: space-between;
      // z-index: 2;
      // overflow: hidden;
      width: 100%;
      flex-direction: row;
      .select-wrap{
        // display: flex;
        // overflow: hidden;
        // flex-grow: 1;
        display: inline-block;
        margin-right: 10px;
        .clear-btn{
          margin-right: 2px;
          transition: color .2s ease;
          display: inline-block;
          line-height:1;
          &:hover{
            color: #888;
          }
        }
        .label{
          display: inline-block;
          line-height:1;
        }
      }
      .placeholder{
        color: #aaa;
        font-size: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: flex;
        input{
          width: 85%;
          border: 0px;
          &[placeholder]{
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
          }
          
          &:focus{
            outline: none !important;
            border: none;
          }
        }
      }
      .space{
        flex-grow: 1;
      }
      .arrow{
        transition: transform .2s ease-in-out;
        &.show{
          transform: rotateZ(-180deg);
        }
      }
    }
    .option-wrapper{
      z-index: 3;
      position: absolute;
      top: 35px;
      left: 0;
      opacity: 0;
      visibility: hidden;
      height: 0;
      background: white;
      min-width: 100%;
      
      
      border: 1px solid #eee;
      box-shadow: 1px 1px 5px #ccc;
      border-radius: 4px;
      transform: scaleY(0);
      transform-origin: center top;
      transition: visibility .1s linear, opacity .1s linear, transform .1s linear;
      
      &.show{
        opacity: 1;
        visibility: visible;
        height: auto;
        transform: scaleY(1);
      }

      input{
        width: calc(100% - 40px);
        height: auto;
        margin: 10px 0 0 10px;
      }
      
      .option-wrapper-content{
        max-height: 120px;
        overflow-y: auto;
        overflow-x: hidden;
        > .option{
          &.active{
            background: #d1d1d1;
          }
          &:not(.not_found):not(.active):hover{
            background: #f1f1f1;
          }
          input[type="checkbox"]{
            width:auto;
            margin:0;
          }
        }
      }
    }
    .option{
      flex-grow: 1;
      padding: 0 10px;
      font-size: 14px;
      height: 25px;
      display: flex;
      align-items: center;
      user-select: none;
      &:not(.not_found) {
        cursor: pointer;
      }
      span,
      .label{
        min-width: 0;
        width: auto !important;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    &.disabled--component{
      background: #ededed;
      .selected{
        cursor: default;
        user-select: auto;
        .label{
          color: #777;
        }
        .arrow{
          color: #777;
        }
      }
    }
  }
  .background-layer{
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
    display: none;
    &.show{
      display: block;
    }
    // background: black;
  }
}
</style>